import CompetitionDashboard from "./CompetitionDashboard";

export default CompetitionDashboard;